export const TOP_BAR_HEIGHT = 36;

export const HEADER_HEIGHT = {
    mobile: 56,
    tablet: 112,
    desktop: 72,
} as const;
